<template>
  <router-view v-if="show" />
</template>

<script>
import config from "@assets/config.json";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      show: false
    };
  },
  async created() { 
    if(!this.user) {
      let tokenData = await this.getDefaultToken();
      if (tokenData) {
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
      }
    }
    this.show = true;
    // 设置默认token
    if (this.token) {
      this.setToken(this.token);
    }
    this.init();
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      token: "getToken",
    }),
    exhibitionId() {
      return config.ExhibitionId;
    }
  },
  methods: {
    ...mapActions({
      getDefaultToken: "loginModule/getDefaultToken",
      getExhibitionById: "exhibitionModule/getExhibitionById"
    }),
    ...mapMutations({ 
      setTokenTime: "setTokenTime",
      setExhibition: "loginModule/setExhibition",
      setToken: "setToken"
    }),
    async init() {
      let exData = await this.getExhibitionById(this.exhibitionId);
      this.setExhibition(exData);
    }
  }
};
</script>

<style lang="scss">
body {
  padding-right: 0 !important;
}
  .ivu-message-custom-content{
    .ivu-icon-ios-information-circle
    {
      font-size: 22px;
    }
    span{
      font-size: 22px;
    }
    .ivu-icon-ios-checkmark-circle{
      font-size: 22px;
    }
  }
  .ivu-message-notice-close{
    top: 16px;
  }
  .ivu-notice{
    top: 10% !important;
    right: 40% !important;
    width: 400px !important;
    .ivu-notice-title{
    font-size: 22px;
   }
  .ivu-notice-desc{
    font-size: 22px;
   }
  }

</style>
